import { createApp } from 'vue'
import { Amplify } from 'aws-amplify'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

// Requested direct client-id wiring for local login flow.
window.__WALL_LABS_COGNITO_CLIENT_ID__ = '5doo9h4vqutnrbgani23emmn7n'

Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID || '',
    region: process.env.VUE_APP_AWS_REGION || 'us-east-1'
  },
  Storage: {
    AWSS3: {
      bucket: process.env.VUE_APP_S3_BUCKET || 'walllabs-bucket',
      region: process.env.VUE_APP_AWS_REGION || 'us-east-1'
    }
  }
})

createApp(App)
.use(router)
.use(vuetify)
.mount('#app')